import ApiService from '@/services/core/api.service'

const PositionService = {
  async get (query) {
    return ApiService.get(`user/positions?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/positions', payload)
  },

  async put (payload) {
    return ApiService.put(`user/positions/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/positions/${payload.id}`)
  }
}

export default PositionService
